import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";

const items = [
  {
    title: "Roadmap, MVP & Strategi Produk",
    desc: "Merancang roadmap, MVP, prioritas fitur, dan strategi produk yang selaras dengan tujuan bisnis.",
    code: "01",
  },
  {
    title: "Arsitektur Solusi End-to-End",
    desc: "Menyusun arsitektur solusi untuk software, hardware, dan integrasi sistem berskala enterprise.",
    code: "02",
  },
  {
    title: "AI, IoT, Backend & Cloud",
    desc: "Membantu pengembangan project AI, IoT, backend, dashboard monitoring, dan deployment cloud.",
    code: "03",
  },
  {
    title: "Freelance Software & Hardware",
    desc: "Terbuka untuk freelance project software dan hardware sesuai kebutuhan bisnis dan teknis Anda.",
    code: "04",
  },
];

const ProfileFocus = () => {
  return (
    <section id="profile-focus" data-testid="profile-focus-section" className="relative py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-5">
          {items.map((it, idx) => (
            <motion.div
              key={idx}
              data-testid={`focus-card-${idx}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              className="group relative rounded-2xl p-7 glass-elevated corners scanline-hover hover:-translate-y-0.5 transition-all duration-300 overflow-hidden"
            >
              <div className="flex items-start gap-5">
                <div className="shrink-0 mt-1 relative">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-500/20 to-indigo-500/10 border border-blue-400/30 grid place-items-center group-hover:shadow-[0_0_24px_rgba(59,130,246,0.35)] transition-shadow">
                    <Check className="w-4 h-4 text-blue-200" strokeWidth={2} />
                  </div>
                  <span className="absolute -top-1.5 -right-2 text-[9px] font-mono-display text-blue-400 bg-[#080d22] px-1.5 rounded border border-blue-400/20">
                    {it.code}
                  </span>
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="text-lg sm:text-xl text-white font-medium" style={{ fontFamily: "Outfit" }}>
                      {it.title}
                    </h3>
                    <ArrowUpRight className="w-4 h-4 text-slate-500 group-hover:text-blue-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                  </div>
                  <p className="mt-2 text-sm text-slate-400 leading-relaxed">{it.desc}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProfileFocus;
